import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Pen icon
 *
 * @category Files/Forms/Editing
 */
const Pen = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M28.892 7.425c-.69-1.125-2.747-2.855-3.678-3.86-.57-.483-1.259-.834-1.73-.29C21.524 5.247 7.15 19.608 5.71 21.06c-.375.424-.339.52-.641 1.283-.436 1.21-1.452 3.944-1.9 5.166-.35.834-.109 1.742.98 1.427 1.646-.629 5.251-1.754 6.715-2.625.714-.702 9.158-9.159 14.264-14.264l3.133-3.134c.533-.52.847-.762.666-1.379l-.049-.109zM4.537 27.28c0-.63.702-2.045.956-2.82.266-.592.4-1.354.823-1.68.774-.11 1.403 1.015 2.238 1.68 1.646 1.453-.4 1.791-1.476 2.203-.665.17-2.069.931-2.504.701zm5.517-2.275c-.593-.423-2.13-2.02-2.71-2.625-.254-.278-.496-.654-.302-.956C8.978 19.451 19.128 9.337 23.084 5.381c.436-.424 1.113-1.32 1.815-.533.702.75 2.238 1.948 2.59 2.831-.836 1.61-3.74 3.811-6.703 7.042-3.23 3.073-7.659 8.057-10.647 10.307l-.097-.024z"
        />
      </svg>
    );
  }
);

Pen.displayName = 'Pen';

export { Pen };
